module.exports = __webpack_public_path__ + "static/assets/91e81a26f85822490d280f29736ccc8b.png";